import React from 'react';
import { Input, Button, InputProps, InputRef } from 'antd';

type AntdButtonType = 'primary' | 'default' | 'dashed' | 'link' | 'text';

type TextInputButton = {
  text: string;
  onClick: () => void;
  type?: AntdButtonType;
};

export interface TextInputProps extends Omit<InputProps, 'ref'> {
  button?: TextInputButton;
  style?: React.CSSProperties;
  groupBefore?: React.ReactNode;
  groupAfter?: React.ReactNode;
}

export const TextInput = React.forwardRef<InputRef, TextInputProps>(
  (props, ref) => {
    const {
      size = 'middle',
      prefix,
      suffix,
      allowClear = false,
      disabled = false,
      readOnly = false,
      type = 'text',
      value,
      defaultValue,
      onChange,
      placeholder,
      button,
      style,
      groupBefore,
      groupAfter,
      ...rest
    } = props;

    const inputNode = (
      <Input
        ref={ref}
        size={size}
        prefix={prefix}
        suffix={suffix}
        allowClear={allowClear}
        disabled={disabled}
        readOnly={readOnly}
        type={type}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          flex: 1,
          borderRadius: 8,
          border: '1px solid #c9c9cd',
        }}
        {...rest}
      />
    );

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, ...style }}>
        {groupBefore}
        {inputNode}
        {groupAfter}
        {button && (
          <Button
            type={button.type ?? 'primary'}
            size={size}
            onClick={button.onClick}
          >
            {button.text}
          </Button>
        )}
      </div>
    );
  },
);

TextInput.displayName = 'TextInput';
